import { FC, FocusEvent } from 'react';
import { Field } from 'formik';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import ArcadeToken from 'ui/components/Icons/ArcadeToken';
import { CbNumberInput } from 'ui/components/Inputs/CbNumberInput';
import { formatNumber } from 'ui/helpers';
export interface CbTokensAmountFieldProps {
  value: number;
  tokenBalance: number;
  error?: string;
  touched?: boolean;
  onBlur: (event: FocusEvent) => void;
  onChange: (val: string) => void;
  isDisabled: boolean;
}
const ArcadeTokenIcon: FC = () => {
  return <ArcadeToken marginLeft={3} data-sentry-element="ArcadeToken" data-sentry-component="ArcadeTokenIcon" data-sentry-source-file="CbTokenAmountField.tsx" />;
};

/**
 * We render the amount through `formatNumber`, so the input's DOM value is
 * thousands-grouped (e.g. `2,558,445`). Chakra's `useNumberInput` defaults the
 * field's HTML5 `pattern` to `[0-9]*(.[0-9]+)?`, which only tolerates a single
 * separator (its `.` is unescaped) — so the browser blocks submit with "Please
 * match the requested format." for any amount >= 1,000,000. Accept grouped or
 * plain digits and let Yup own the actual validation.
 */
const GROUPED_NUMBER_PATTERN = '[0-9]{1,3}(,[0-9]{3})*|[0-9]+';
export const CbTokensAmountField: FC<CbTokensAmountFieldProps> = ({
  error,
  touched,
  value,
  onBlur,
  onChange,
  ...props
}) => {
  const isInvalid = !!error && touched;
  return <FormControl isInvalid={isInvalid} data-sentry-element="FormControl" data-sentry-component="CbTokensAmountField" data-sentry-source-file="CbTokenAmountField.tsx">
      <FormLabel htmlFor="amount" data-sentry-element="FormLabel" data-sentry-source-file="CbTokenAmountField.tsx">How much?</FormLabel>

      <Field id="arcade" name="arcade" component={CbNumberInput} type="number" icon={ArcadeTokenIcon} inputFieldProps={{
      paddingLeft: 8,
      pattern: GROUPED_NUMBER_PATTERN
    }} isInvalid={isInvalid} onChange={onChange} onBlur={onBlur} placeholder="Number of Tokens" value={value > 0 ? formatNumber(value) : value} error={error} variant="cb-base" {...props} data-sentry-element="Field" data-sentry-source-file="CbTokenAmountField.tsx" />
      <FormErrorMessage marginLeft={2} marginTop=".5rem" paddingTop={0} data-sentry-element="FormErrorMessage" data-sentry-source-file="CbTokenAmountField.tsx">
        {error}
      </FormErrorMessage>
    </FormControl>;
};